import { defineMessages } from 'react-intl';

export default defineMessages({

    addRequal: {
        id: "gateway.views.policy-detail-summary_tfpa.Add Requalification",
        defaultMessage: "Add Requalification"
    },
    requalMsg: {
        id: "gateway.views.policy-detail-summary_tfpa.requalificationTitle",
        defaultMessage: "I am representing that diligent effort has been made by the agent and/or policyholder to obtain comparable residential property insurance coverage from a residential property insurance carrier in Texas that is licensed to write and actually writing residential property insurance. I am representing that I have discussed the FAIR Plan eligibility requirements with the policyholder and have determined, to the best of my knowledge, the above named policyholder is eligible to continue coverage with the Texas FAIR Plan. I understand that the Texas FAIR Plan Association may independently verify the information, and that my authority to write business with the Texas FAIR Plan may be suspended and/or cancelled if I have in any way misrepresented this information."
    },
    requalSubmittedTitle: {
        id: "gateway.views.policy-detail-summary_tfpa.Submitted Requalification",
        defaultMessage: "Submitted Requalification"
    },
    requalSubtitle: {
        id: "gateway.views.policy-detail-summary_tfpa.submitted subtitle",
        defaultMessage: "Your renewal request and updated declination have been received and referred to underwriting.Thank you"
    },
    doneButton: {
        id: "gateway.views.policy-detail-summary_tfpa.close ",
        defaultMessage: "Close"
    },
    requalificationQuestionErrorMsg: {
        id: "gateway.views.policy-detail-summary__tfpa.requalificationError",
        defaultMessage: "Error Processing Re-Qualification Questions"
    }
})